class Dirty {
  static isPriceTermHidden(gymId?: number) {
    return [217].includes(gymId!)
  }
}

export { Dirty }
